import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { setToken } from "../lib/tokenStore";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = m[1];

    const referral_code = localStorage.getItem("thqah_pending_ref") || null;

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id, referral_code });
        setToken(data.token);
        if (referral_code) localStorage.removeItem("thqah_pending_ref");
        await refresh();

        // New users (or anyone who hasn't completed onboarding) must add their
        // name + GCC phone before reaching the dashboard. We treat onboarding
        // as required when phone or full_name is missing OR backend flagged
        // is_new_user / onboarding_complete=false.
        const u = data.user || {};
        const needsOnboarding =
          u.is_new_user === true || !u.onboarding_complete;

        toast.success(`Welcome, ${u.full_name || ""}`);
        const dest = needsOnboarding
          ? "/onboarding"
          : u.role === "admin"
            ? "/admin"
            : u.role === "expert"
              ? "/expert"
              : "/dashboard";
        nav(dest, { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Login failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="mx-auto max-w-md px-5 py-20 text-center" data-testid="auth-callback">
      <div className="h-12 w-12 rounded-full mx-auto animate-pulse" style={{ background: "linear-gradient(135deg, #F9E596, #AA8000)" }} />
      <p className="text-white/60 mt-6">Signing you in...</p>
    </div>
  );
}
